import { formatDate } from "./crmHelpers";

/*
  Mensagens prontas de WhatsApp.

  A pessoa ainda revisa no próprio WhatsApp antes de enviar: o texto só abre preenchido.
  Por isso nada aqui diz que algo já foi feito pela equipe, e o link da fatura só entra
  quando existe de verdade. Sem link, a mensagem pede que a conta olhe a fatura e a tela
  de assinatura continua sendo o lugar de reenviá-lo.

  `QUEUE_TEMPLATE` liga cada fila à mensagem que combina com ela: é a sugerida quando a
  conta está naquela situação. O que as filas são continua vindo do servidor. Fila nova
  sem mensagem aqui só deixa de ter sugestão, e a lista completa segue disponível.
*/

const firstName = (name) => String(name || "").trim().split(/\s+/)[0] || "";

const intro = ({ agentName }) =>
  agentName
    ? `Oi, tudo bem? Aqui é ${firstName(agentName)}, da Relinq.`
    : "Oi, tudo bem? Aqui é da Relinq.";

const invoiceLine = ({ paymentUrl }) =>
  paymentUrl ? `\n\nO link da fatura é este: ${paymentUrl}` : "";

export const CONTACT_TEMPLATES = [
  {
    id: "subscription_overdue",
    label: "Cobrança em atraso",
    text: (data) =>
      `${intro(data)} Vi que a cobrança da assinatura de ${data.name} ficou em aberto, e queria ajudar a resolver antes que o acesso seja afetado.${invoiceLine(data)}\n\nDeu algum problema no pagamento?`,
  },
  {
    id: "first_payment",
    label: "1º pagamento pendente",
    text: (data) =>
      `${intro(data)} Vi que a assinatura de ${data.name} já foi criada e falta só o primeiro pagamento para o plano começar a valer.${invoiceLine(data)}\n\nSe tiver alguma dúvida, me chama por aqui.`,
  },
  {
    id: "renewal",
    label: "Renovação do plano",
    text: (data) =>
      `${intro(data)} O plano de ${data.name} vence em ${data.expiration}. Quer ajuda para renovar e não ficar sem o sistema?`,
  },
  {
    id: "first_steps",
    label: "Ajuda para começar",
    text: (data) =>
      `${intro(data)} Vi que ${data.name} criou a conta e ainda não fez o primeiro agendamento. Posso te ajudar a deixar tudo pronto? Em poucos minutos a gente faz o primeiro junto.`,
  },
  {
    id: "upgrade",
    label: "Oferecer upgrade",
    text: (data) =>
      `${intro(data)} Vi que ${data.name} está usando bastante o sistema. Posso te mostrar o que muda com um plano pago? Lembretes automáticos e o fluxo de caixa costumam fazer diferença nessa fase.`,
  },
  {
    id: "over_seats",
    label: "Ajustar equipe no plano",
    text: (data) =>
      `${intro(data)} Vi que a equipe de ${data.name} cresceu e já passou do que o plano atual cobre. Posso te ajudar a ajustar o plano para a equipe de hoje?`,
  },
  {
    id: "usage_drop",
    label: "Uso caiu",
    text: (data) =>
      `${intro(data)} Notei que ${data.name} tem usado menos o sistema nas últimas semanas. Aconteceu alguma coisa? Se algo estiver travando, quero ajudar a resolver.`,
  },
  {
    id: "winback",
    label: "Reconquistar",
    text: (data) =>
      `${intro(data)} Faz um tempo que ${data.name} não está com a gente, e eu queria entender o que faltou. Posso te contar o que mudou por aqui?`,
  },
  {
    id: "check_in",
    label: "Só saber como está",
    text: (data) =>
      `${intro(data)} Passando para saber como estão as coisas em ${data.name}. Posso ajudar em alguma coisa no sistema?`,
  },
];

const QUEUE_TEMPLATE = {
  subscription_overdue: "subscription_overdue",
  subscription_first_payment: "first_payment",
  renewal_at_risk: "renewal",
  new_never_started: "first_steps",
  dormant_rescue: "first_steps",
  free_ready_to_pay: "upgrade",
  over_seat_limit: "over_seats",
  usage_dropping: "usage_drop",
  paying_disengaged: "usage_drop",
  free_slipping: "usage_drop",
  churn_winback: "winback",
};

export const templateForQueue = (queueId) =>
  CONTACT_TEMPLATES.find((template) => template.id === QUEUE_TEMPLATE[queueId]) ||
  null;

const buildData = ({ account = {}, paymentUrl, agentName }) => ({
  name: account.name || "sua conta",
  expiration: account.planExpirationDate
    ? formatDate(account.planExpirationDate)
    : "breve",
  paymentUrl,
  agentName,
});

/** O texto final da mensagem. */
export const renderTemplate = (template, context) =>
  template.text(buildData(context));

/** O registro que fica no histórico: qual mensagem foi aberta e o que ela dizia. */
export const describeContact = (template, message) =>
  template
    ? `WhatsApp aberto com a mensagem "${template.label}":\n\n${message}`
    : "WhatsApp aberto, sem mensagem pronta.";
